import React from "react";
import { useSelector } from "react-redux";
import { getAccountInvoices } from "../selectors/currentAccountSelector.ts";
import ProfilePaymentHistory from "./helpers/ProfilePaymentHistory.jsx";

import styles from "../styles/UserSubscription.module.scss";

export default function ProfilePaymentHistoryPage(props) {
  const invoices = useSelector(getAccountInvoices);

  return (
    // <BreadcrumbWrapper breadcrumbs={breadcrumbs}>
    <div className={styles.userSubscriptionWrapper}>
      <h1>Payment History</h1>
      <div className={styles.subHeader}>
        <h2>Recent History</h2>
        <hr />
        <ProfilePaymentHistory invoices={invoices} fullPage />
      </div>
    </div>
    // </BreadcrumbWrapper>
  );
}
